import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";

const Actions = {
  setError: "setError",
  resetError: "resetError",
};

//actions
export const setError = createAction(Actions.setError);
export const resetError = createAction(Actions.resetError);

export const getError = (state, screen) => {
  const errorData = get(state, "error.errorObj", {});
  const currentScreen = get(state, "error.errorObj.screen", "");
  if (currentScreen === screen) {
    return errorData;
  }
  return {};
};

export const getFetchFailed = (state, screen) => {
  const currentScreen = get(state, "error.errorObj.screen", "");
  if (currentScreen === screen) {
    return state.error.errorObj.isFetchFailed;
  }
  return false;
};

export const getUpdateFailed = (state, screen) => {
  const currentScreen = get(state, "error.errorObj.screen", "");
  if (currentScreen === screen) {
    return state.error.errorObj.isUpdateFailed;
  }
  return false;
};

export const getErrorMessage = (state, screen) => {
  const currentScreen = get(state, "error.errorObj.screen", "");
  if (currentScreen === screen) {
    return state.error.errorObj.message;
  }
  return "";
};

// initialState
const initialState = {
  errorObj: {
    screen: "",
    isFetchFailed: false,
    isUpdateFailed: false,
    message: "",
  },
};

//reducer
export default createReducer(initialState, (builder) => {
  builder.addCase(setError, (state, action) => {
    state.errorObj = {
      ...state.errorObj,
      ...action.payload
    };
  });
  builder.addCase(resetError, (state, action) => {
    state.errorObj = {
      ...state,
      ...action.payload
    };
  });
});
